import { FC, useEffect, useState } from "react"
import * as toGeoJson from "@tmcw/togeojson"

type Props = {
  handleForm: (form: any) => void
}

export const UpdateMapsData: FC<Props> = (props) => {
  const [geojsonFile, setGeojsonFile] = useState<any>(null)
  const [kmlFileName, setKmlFileName] = useState("")

  const handleFileUpload = (event: React.ChangeEvent<HTMLInputElement>) => {
    const reader = new FileReader()
    const selectedFile = event.target.files?.[0]
    if (selectedFile) {
      reader.onload = (ev) => {
        handleDroppedFileToMap(reader.result as string, selectedFile.name)
      }
      reader.readAsText(selectedFile, "text/xml")
    }
  }

  const handleDroppedFileToMap = (fileResult: string, fileName: string) => {
    const geojson = toGeoJson.kml(
      new DOMParser().parseFromString(fileResult, "text/xml"),
    )
    setGeojsonFile(geojson)
    setKmlFileName(fileName)
  }

  useEffect(() => {
    if (geojsonFile !== null) {
      props.handleForm({
        mapsData: JSON.stringify(geojsonFile, null, 2),
      })
    }
  }, [geojsonFile])

  return (
    <div className="md:gap-2 gap-4 px-16 pt-48 grid-cols-3 grid  place-items-center">
      <div className="md:col-span-2 col-span-3 w-full flex justify-end">
        <div className="lg:w-3/5 w-full text-start bg-transparent text-primary-16 text-sm border-2  dark:border-secondary-1 border-primary-3 shadow-md rounded-md px-3 py-2 cursor-pointer">
          {!kmlFileName ? " Upload kml file here" : kmlFileName}
        </div>
      </div>
      <div className="md:col-span-1 col-span-3 md:justify-start justify-end flex w-full">
        <fieldset>
          <input
            className="hidden"
            onChange={handleFileUpload}
            id="kml_file"
            type="file"
            accept=".kml"
          />
          <label
            className="px-10 py-2 bg-primary-3 text-md rounded-md text-center dark:text-secondary-4 text-primary-1 font-semibold shadow-black cursor-pointer"
            htmlFor="kml_file"
          >
            Select file
          </label>
        </fieldset>
      </div>
    </div>
  )
}
